
const ServicesHero = () => {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f8b6d3123b70ff238f2c8d6d88eee119.jpg"
          alt="Servicios profesionales de vaciado y limpieza"
          className="w-full h-full object-cover object-top"
          loading="eager"
          fetchpriority="high"
          width="1920"
          height="1080"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <span className="inline-block px-6 py-2 bg-white/20 backdrop-blur-sm text-white rounded-full text-sm font-semibold mb-6">
          Nuestros servicios
        </span>
        
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Soluciones completas de<br />
          <span className="text-primary">vaciado y limpieza</span>
        </h1>
        
        <p className="text-xl text-white/90 max-w-3xl mx-auto mb-10 leading-relaxed">
          Ofrecemos servicios profesionales de vaciado de pisos, locales comerciales, limpieza extrema y síndrome de Diógenes en Castelldefels, Gavà, Viladecans, El Prat de Llobregat, Sant Boi, Sitges y toda la comarca del Baix Llobregat Sud. Servicio disponible 24 horas, 7 días a la semana con presupuesto sin compromiso.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:+34602365996"
            className="w-full sm:w-auto px-6 sm:px-8 py-4 bg-primary text-white rounded-lg font-semibold text-base sm:text-lg hover:bg-primary-dark hover:shadow-glow transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Presupuesto
          </a>
          <a
            href="https://wa.me/34602365996"
            className="w-full sm:w-auto px-6 sm:px-8 py-4 bg-white text-graphite rounded-lg font-semibold text-base sm:text-lg hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line mr-2"></i>
            WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
